import { render } from "./B2bPageRemadvDetail.vue?vue&type=template&id=6538683c&scoped=true&lang=pug"
import script from "./B2bPageRemadvDetail.vue?vue&type=script&lang=js"
export * from "./B2bPageRemadvDetail.vue?vue&type=script&lang=js"

import "./B2bPageRemadvDetail.vue?vue&type=style&index=0&id=6538683c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6538683c"]])

export default __exports__